<div class="wrapper_generate_reports">
  <button
    class="button button__generate-reports"
    (click)="generateAllReports()"
  >
    Generate reports
  </button>
  <ng-container *ngIf="visibilityText">
    <span class="reports_text">
      The reports have been generated for each employee. If needed, you can
      <b (click)="sendReports()"> send it</b>
    </span>
  </ng-container>
</div>
